import { createAction } from 'redux-actions';
import types from '../types';

export const initializeApp = createAction(types.INITIALIZE_APP);
export const cancelInitializeApp = createAction(types.CANCEL_INITIALIZE_APP);
